<template>
	<input type="text" v-model="text" @input="onInput" @blur="onChange" placeholder="00:00" maxlength="6" />
</template>

<script>
    export default {
		name: 'TimeInput',
		props: {
			value: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				text: this.value
			}
		},
		watch: {
			value: {
				immediate: true,
				handler(newValue, oldValue) {
					this.text = newValue
				}
			}
		},
		methods: {
			onInput(e) {
				this.text = this.text.replaceAll(":", "")
				this.text = isNaN(parseInt(e.data)) ? this.text.replace(e.data, "") : this.text

				this.$emit("input", this.text)
			},
			onChange(e) {
				if (e.currentTarget.value === "")
					return

				this.text = this.text.replaceAll(":", "")

				if (parseInt(this.text) < 10)
					this.text = this.text.padStart(2, "0")

				if (parseInt(this.text.substring(0, 2)) > 23)
					this.text = "23"

				this.text = this.text.padEnd(4, "0")

				if (this.text.indexOf(":") == -1 && this.text.length > 3) {
					this.text = this.text.substring(this.text.length - 4, this.text.length + 1)
				}

				var arr = this.text.split('')

				arr.splice(2, 0, ":")

				this.text = arr.join('')

				this.$emit("input", this.text)
			}
		}
    }
</script>

<style scoped>
</style>